export function generateSessionId(length = 18) {
  const prefix = "session_";
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";

  // Prefer cryptographically-strong randomness when available
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = new Uint8Array(length);
    crypto.getRandomValues(bytes);
    let out = "";
    for (let i = 0; i < bytes.length; i++) {
      out += chars[bytes[i] % chars.length];
    }
    return `${prefix}${out}`;
  }

  // Fallback
  let out = "";
  for (let i = 0; i < length; i++) {
    out += chars[Math.floor(Math.random() * chars.length)];
  }
  return `${prefix}${out}`;
}



